// 260703nrai: poll for new messages and show live toasts
function initMessagesPoll() {
  const pollUrl = document.body.dataset.messagesPollUrl;
  if (!pollUrl) return;

  if (!window.toast_manager) return;

  const inboxUrl = document.body.dataset.messagesInboxUrl || '/messages/inbox?tab=in&unread_only=false';
  const pollStorageKey = 'messages_poll_last_at';
  const shownStorageKey = 'messages_toast_shown';
  const storedPollAt = sessionStorage.getItem(pollStorageKey);
  let lastPollAt = storedPollAt || new Date(Date.now() - 5 * 60 * 1000).toISOString();
  const shownIds = new Set(JSON.parse(sessionStorage.getItem(shownStorageKey) || '[]'));

  function saveShownIds() {
    sessionStorage.setItem(shownStorageKey, JSON.stringify(Array.from(shownIds).slice(-200)));
  }

  function poll() {
    fetch(`${pollUrl}?since=${encodeURIComponent(lastPollAt)}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) throw new Error(`poll ${response.status}`);
        return response.json();
      })
      .then((payload) => {
        const messages = payload.new_messages || [];
        let latestCreatedAt = lastPollAt;

        messages.forEach((message) => {
          if (message.created_at && message.created_at > latestCreatedAt) {
            latestCreatedAt = message.created_at;
          }
          if (shownIds.has(String(message.id))) return;
          shownIds.add(String(message.id));
          saveShownIds();

          const link = `<a href="${inboxUrl}&amp;id=${message.id}" class="clickable_text">Jetzt ansehen.</a>`;
          window.toast_manager.push_many([{
            kind: 'success',
            html: `Sie haben eine neue Nachricht von ${message.from} mit dem Betreff ${message.subject} erhalten. ${link}`,
            duration_ms: 8000
          }]);
        });

        lastPollAt = latestCreatedAt !== lastPollAt ? latestCreatedAt : new Date().toISOString();
        sessionStorage.setItem(pollStorageKey, lastPollAt);
      })
      .catch(() => {});
  }

  poll();
  window.setInterval(poll, 60000);
}

window.initMessagesPoll = initMessagesPoll;

export { initMessagesPoll };
